import MediaResource from './media-resource';

export default class Sketch extends MediaResource {
  get defaultContentType() {
    return 'image/jpeg';
  }

  get resourceName() {
    return 'sketch';
  }

  get resourcesName() {
    return 'sketches';
  }

  large(id: string, callback: (err: Error, result: any) => void) {
    return this.downloadVersion(id, 'large', callback);
  }

  largeURL(id: string) {
    return this.client.url(this.memberAction(id, 'large', 'jpg'));
  }

  thumbnail(id: string, callback: (err: Error, result: any) => void) {
    return this.downloadVersion(id, 'thumbnail', callback);
  }

  thumbnailURL(id: string) {
    return this.client.url(this.memberAction(id, 'thumbnail', 'jpg'));
  }
}
